// extracted by mini-css-extract-plugin
module.exports = {"container":"Paginate_container__3SRqP","limit":"Paginate_limit__o-jC9","page":"Paginate_page__JS9Dz"};